export const VALUE_PLACEHOLDER = '{V}';
export const CURRENCY_CODE_PLACEHOLDER = '{S}';
const getPrefixSpacedFormat = (symbol) => `${symbol} ${VALUE_PLACEHOLDER}`;
const getPrefixFormat = (symbol) => `${symbol}${VALUE_PLACEHOLDER}`;
const getSuffixSpacedFormat = (symbol) => `${VALUE_PLACEHOLDER} ${symbol}`;
export const defaultCurrencyFormatConfig = {
    decimalDigits: 2,
};
export const getCurrencyFormat = ({ suffix, spaced, symbol }) => {
    if (symbol) {
        if (suffix && spaced) {
            return getSuffixSpacedFormat(symbol);
        }
        else if (spaced) {
            return getPrefixSpacedFormat(symbol);
        }
        else {
            return getPrefixFormat(symbol);
        }
    }
    return `${CURRENCY_CODE_PLACEHOLDER} ${VALUE_PLACEHOLDER}`;
};
// NOTE: visual prices shown in cards, previews, etc. use a different formatter with possibly different decimal digits
// TWD and COP have incorrect/overridden decimalDigits, because of past issues + to be aligned with back-end
// example of an issue - PayPal doesn't handle TWD with decimal digits
export const currencyFormatConfig = {
    BIF: { symbol: 'FBu', decimalDigits: 0 },
    CVE: { symbol: '$', decimalDigits: 2 },
    KMF: { symbol: 'CF', decimalDigits: 0 },
    CDF: { symbol: 'FC', decimalDigits: 2 },
    DJF: { symbol: 'Fdj', decimalDigits: 0 },
    ERN: { symbol: 'ERN', decimalDigits: 2 },
    GNF: { symbol: 'FG', decimalDigits: 0 },
    LSL: { symbol: 'L', decimalDigits: 2 },
    LYD: { symbol: 'ل.د', decimalDigits: 3 },
    MWK: { symbol: 'MK', decimalDigits: 2 },
    MRO: { symbol: 'UM', decimalDigits: 0 },
    SLL: { symbol: 'LE', decimalDigits: 2 },
    SZL: { symbol: 'L', decimalDigits: 2 },
    TJS: { symbol: 'TJS', decimalDigits: 2 },
    TOP: { symbol: 'T$', decimalDigits: 2 },
    XPF: { symbol: 'F', decimalDigits: 0 },
    XOF: { symbol: 'CFA', decimalDigits: 0 },
    XAF: { symbol: 'FCFA', decimalDigits: 0 },
    WST: { symbol: 'WS$', decimalDigits: 2 },
    VUV: { symbol: 'VT', decimalDigits: 0 },
    UGX: { symbol: 'USh', decimalDigits: 0 },
    TZS: { symbol: '/=', decimalDigits: 2 },
    STD: { symbol: 'Db', decimalDigits: 0 },
    RWF: { symbol: 'R₣', decimalDigits: 0 },
    PGK: { symbol: 'K', decimalDigits: 2 },
    MVR: { symbol: 'Rf', decimalDigits: 2 },
    MOP: { symbol: 'MOP$', decimalDigits: 2 },
    MMK: { symbol: 'K', decimalDigits: 2 },
    MDL: { symbol: 'L', decimalDigits: 2 },
    HTG: { symbol: 'G', decimalDigits: 2 },
    GMD: { symbol: 'D', decimalDigits: 2 },
    GEL: { symbol: 'GEL', decimalDigits: 2 },
    ETB: { symbol: 'Br', decimalDigits: 2 },
    BTN: { symbol: 'Nu.', decimalDigits: 2 },
    BDT: { symbol: '৳', decimalDigits: 2 },
    AOA: { symbol: 'Kz', decimalDigits: 2 },
    AED: { symbol: 'AED', decimalDigits: 2 },
    MGA: { symbol: 'Ar', decimalDigits: 2 },
    GHS: { symbol: 'GH₵', decimalDigits: 2 },
    TMT: { symbol: 'T', decimalDigits: 2 },
    DZD: { symbol: 'دج', decimalDigits: 2 },
    MAD: { symbol: 'د.م.', decimalDigits: 2 },
    KWD: { symbol: 'د.ك', decimalDigits: 3 },
    TND: { symbol: 'د.ت', decimalDigits: 3 },
    RUB: { symbol: 'руб.', decimalDigits: 2, spaced: true },
    AZN: { symbol: 'ман', decimalDigits: 2 },
    BGN: { symbol: 'лв', decimalDigits: 2 },
    UZS: { symbol: 'сум', decimalDigits: 2 },
    KZT: { symbol: '₸', decimalDigits: 2 },
    KGS: { symbol: 'сом', decimalDigits: 2 },
    RSD: { symbol: 'РСД', decimalDigits: 2 },
    MKD: { symbol: 'ден', decimalDigits: 2 },
    PLN: { symbol: 'zł', decimalDigits: 2 },
    TTD: { symbol: 'TT$', decimalDigits: 2 },
    PEN: { symbol: 'S/.', decimalDigits: 2 },
    SOS: { symbol: 'S', decimalDigits: 2 },
    IDR: { symbol: 'Rp', decimalDigits: 2 },
    MYR: { symbol: 'RM', decimalDigits: 2 },
    DOP: { symbol: 'RD$', decimalDigits: 2 },
    BRL: { symbol: 'R$', decimalDigits: 2 },
    ZAR: { symbol: 'R', decimalDigits: 2 },
    GTQ: { symbol: 'Q', decimalDigits: 2 },
    BYN: { symbol: 'p.', decimalDigits: 2 },
    BWP: { symbol: 'P', decimalDigits: 2 },
    TWD: { symbol: 'NT$', decimalDigits: 0 },
    MZN: { symbol: 'MT', decimalDigits: 2 },
    ALL: { symbol: 'Lek', decimalDigits: 2 },
    RON: { symbol: 'lei', decimalDigits: 2 },
    HNL: { symbol: 'L', decimalDigits: 2 },
    KES: { symbol: 'Ksh', decimalDigits: 2 },
    SEK: { symbol: 'kr', decimalDigits: 2, suffix: true, spaced: true },
    NOK: { symbol: 'kr', decimalDigits: 2, suffix: true, spaced: true },
    ISK: { symbol: 'kr', decimalDigits: 0 },
    DKK: { symbol: 'kr', decimalDigits: 2, suffix: true, spaced: true },
    HRK: { symbol: 'kn', decimalDigits: 2 },
    BAM: { symbol: 'KM', decimalDigits: 2 },
    CZK: { symbol: 'Kč', decimalDigits: 2 },
    JOD: { symbol: 'JD', decimalDigits: 3 },
    JMD: { symbol: 'J$', decimalDigits: 2 },
    PYG: { symbol: 'Gs', decimalDigits: 0 },
    AWG: { symbol: 'ƒ', decimalDigits: 2 },
    ANG: { symbol: 'ƒ', decimalDigits: 2 },
    HUF: { symbol: 'Ft', decimalDigits: 2 },
    CHF: { symbol: 'CHF', decimalDigits: 2 },
    NIO: { symbol: 'C$', decimalDigits: 2 },
    BZD: { symbol: 'BZ$', decimalDigits: 2 },
    VEF: { symbol: 'Bs', decimalDigits: 2 },
    PAB: { symbol: 'B/.', decimalDigits: 2 },
    YER: { symbol: '﷼', decimalDigits: 2 },
    SAR: { symbol: '﷼', decimalDigits: 2 },
    QAR: { symbol: '﷼', decimalDigits: 2 },
    OMR: { symbol: '﷼', decimalDigits: 3 },
    SCR: { symbol: '₨', decimalDigits: 2 },
    PKR: { symbol: '₨', decimalDigits: 2 },
    NPR: { symbol: '₨', decimalDigits: 2 },
    MUR: { symbol: '₨', decimalDigits: 2 },
    LKR: { symbol: '₨', decimalDigits: 2 },
    UAH: { symbol: '₴', decimalDigits: 2 },
    PHP: { symbol: '₱', decimalDigits: 2 },
    MNT: { symbol: '₮', decimalDigits: 2 },
    LAK: { symbol: '₭', decimalDigits: 2 },
    EUR: { symbol: '€', decimalDigits: 2 },
    VND: { symbol: '₫', decimalDigits: 0 },
    ILS: { symbol: '₪', decimalDigits: 2 },
    KRW: { symbol: '₩', decimalDigits: 0 },
    NGN: { symbol: '₦', decimalDigits: 2 },
    CRC: { symbol: '₡', decimalDigits: 2 },
    KHR: { symbol: '៛', decimalDigits: 2 },
    THB: { symbol: '฿', decimalDigits: 2 },
    AFN: { symbol: '؋', decimalDigits: 2 },
    JPY: { symbol: '¥', decimalDigits: 0 },
    CNY: { symbol: '¥', decimalDigits: 2 },
    FKP: { symbol: '£', decimalDigits: 2 },
    SHP: { symbol: '£', decimalDigits: 2 },
    GIP: { symbol: '£', decimalDigits: 2 },
    LBP: { symbol: '.ل.ل', decimalDigits: 2 },
    GBP: { symbol: '£', decimalDigits: 2 },
    EGP: { symbol: '£', decimalDigits: 2 },
    UYU: { symbol: '$U', decimalDigits: 2 },
    BOB: { symbol: '$b', decimalDigits: 2 },
    USD: { symbol: '$', decimalDigits: 2 },
    BMD: { symbol: 'BD$', decimalDigits: 2 },
    SBD: { symbol: '$', decimalDigits: 2 },
    XCD: { symbol: '$', decimalDigits: 2 },
    SGD: { symbol: '$', decimalDigits: 2 },
    NZD: { symbol: '$', decimalDigits: 2 },
    MXN: { symbol: '$', decimalDigits: 2 },
    LRD: { symbol: '$', decimalDigits: 2 },
    KYD: { symbol: '$', decimalDigits: 2 },
    HKD: { symbol: '$', decimalDigits: 2 },
    GYD: { symbol: '$', decimalDigits: 2 },
    FJD: { symbol: '$', decimalDigits: 2 },
    COP: { symbol: '$', decimalDigits: 0 },
    CLP: { symbol: '$', decimalDigits: 0 },
    CAD: { symbol: '$', decimalDigits: 2 },
    BSD: { symbol: '$', decimalDigits: 2 },
    BND: { symbol: '$', decimalDigits: 2 },
    BBD: { symbol: '$', decimalDigits: 2 },
    AUD: { symbol: '$', decimalDigits: 2 },
    ARS: { symbol: '$', decimalDigits: 2 },
    NAD: { symbol: '$', decimalDigits: 2 },
    SRD: { symbol: '$', decimalDigits: 2 },
    BHD: { symbol: '.د.ب', decimalDigits: 3 },
    AMD: { symbol: 'AMD', decimalDigits: 2 },
    TRY: { symbol: '₺', decimalDigits: 2 },
    INR: { symbol: '₹', decimalDigits: 2 },
    IQD: { symbol: 'ع.د', decimalDigits: 2 },
    ZMW: { symbol: 'ZK', decimalDigits: 2 },
};
//# sourceMappingURL=currency-format-config.js.map